module.exports = __webpack_public_path__ + "public/img/vitamin.c2e04912.png";